<template>
  <div id="sale">
    <transition name="fade-expand" mode="out-in">
      <h2 v-show="!saleId" class="">セール</h2>
    </transition>
    <div style="">
      <transition name="fade-expand" mode="out-in">
        <nav-tabs v-show="!saleId" :tab="tab" />
      </transition>
      <tab-content :tab="tab"></tab-content>
    </div>
  </div>
</template>

<script>
import NavTabs from './components/NavTabs'
import TabContent from './components/TabContent'
import tabs from '@/common/sale-tabs'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      loader: null,
      isShowNavTab: true
    }
  },
  computed: {
    allowTabs () {
      return tabs.map(tab => tab.id)
    },
    tab () {
      return this.$route.params.tab
    },
    saleId () {
      return this.$route.params.saleId
    }
  },
  created () {
    if (this.tab && !this.allowTabs.includes(this.tab)) {
      this.$router.push('/not-found')
    }
  },
  mounted () {
    this.$events.listen('handleError', (err) => {
      this.$store.commit('toggleModal', {
        show: true,
        message: err
      })
    })
  },
  watch: {
    $route (to) {
      const toTab = to.params.tab
      if (toTab && !this.allowTabs.includes(toTab)) {
        this.$router.push('/not-found')
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style>
#sale {
  background-color: #f1f3f6;
  padding: 0 40px;
}
.fade-expand-enter-active,
.fade-expand-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-expand-enter, .fade-expand-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.expand-card-enter-active, .expand-card-leave-active {
  transition: all 0.4s ease;
}
.expand-card-enter-from, .expand-card-leave-to {
  transform: scale(0.95);
  opacity: 0;
}

.sale-entry-enter-active {
  animation: entry-expand 0.4s ease-out forwards;
}
@keyframes entry-expand {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 425px) {
  #sale {
    padding: 0 10px;
  }
}
</style>
<style>
.text-size-30 {
  font-size: 30px;
}
.mobile {
  display: none;
}
@media (max-width: 425px) {
  .mobile-hidden {
    display: none;
  }
  .mobile {
    display: block;
  }
  .panel-body {
    padding: 10px;
  }
  .col-md-12 {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/Sale.vue